export default __webpack_public_path__ + "static/media/heroGif600_5.4870792a.gif";